import { createContext } from 'react';
import { TemplateContextData } from './interfaces/template-context-props.interface';

const TemplateContext = createContext<TemplateContextData>(
    {} as TemplateContextData,
);

export default TemplateContext;
